import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "app-card-reception",
	templateUrl: "./card-reception.component.html",
})
export class CardReceptionComponent implements OnInit {
	@Input() numero: string;
	@Input() project: string;
	@Input() date: string;
	@Input() status: boolean;
	@Input() fournisseur: string;
	constructor() {}

	ngOnInit() {}
}
